export enum EvaluationStatus {
  STARTED = 'started', // the user has an unfinished evaluation
  WAITING_REVIEW = 'waiting_review', // the user finished the evaluation and is waiting for the doctor comments
  EVALUATED = 'evaluated', // eligible
  INVALID_DATA = 'invalid_data', // not eligible (bad pictures)
}
